// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Geist Mono', monaco, monospace","fontStyle":"normal"},"className":"__className_a30a86","variable":"__variable_a30a86"};